module.exports = __webpack_public_path__ + "img/Angular_Icon.8ca579fd.png";